<template>
  <div class="filter flex flex-col justify-center align-middle content-center">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BoxFilter"
};
</script>

<style lang="scss" scoped>
.filter {
  height: 4.2rem;
  flex: 0 0 4.2rem;
}

@media (min-width: 768px) {
  .filter {
    height: 4.8rem;
    flex: 0 0 4.8rem;
  }
}

@media (min-width: 1024px) {
  .filter {
    height: fit-content;
    flex: 0 0 0;
    margin-bottom: 1rem;
  }
}
</style>
